import React from "react";
import "./style.css";
import UnAuthorizedImg from './401.svg';
import { Button, Icon } from 'antd';
import { withRouter } from "react-router-dom";
import { history } from '../../container/History';

class UnAuthorized extends React.Component {
  handleClick = () => {
    history.push("/Dashboard");
  }

  render() {
    return (
      <div className="unauthorized">
        <img src={UnAuthorizedImg} />
      </div>
    )
  }
}

export default withRouter(UnAuthorized);


// WEBPACK FOOTER //
// ./src/components/UnAuthorized/index.js